import { createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/images/search_icon.png'


const _hoisted_1 = { class: "search-detail-page" }
const _hoisted_2 = { class: "search-detail-page-top-view" }
const _hoisted_3 = { class: "search-detail-page-top-view-area" }
const _hoisted_4 = { class: "commonSearchInputViewArea" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "commonSearchIconArea" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "commonSearchIcon",
    src: _imports_0
  })
], -1)
const _hoisted_6 = { class: "search-detail-page-bottom-view" }
const _hoisted_7 = { class: "search-detail-page-button-view-area" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "search-detail-page-button-clear" }, [
  /*#__PURE__*/_createVNode("div", { class: "search-detail-page-button-text" }, "クリア")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "search-detail-page-button-search" }, [
  /*#__PURE__*/_createVNode("div", { class: "search-detail-page-button-text" }, "検索する")
], -1)
const _hoisted_10 = { class: "search-detail-page-list-view" }
const _hoisted_11 = { class: "search-detail-page-appliance-area" }
const _hoisted_12 = { class: "commonTextBodyDefault" }
const _hoisted_13 = { class: "search-detail-page-tag-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchTagList = _resolveComponent("SearchTagList")
  const _component_CommonDialog = _resolveComponent("CommonDialog")
  const _component_ApplianceDialog = _resolveComponent("ApplianceDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode("input", {
            ref: "textInput",
            class: "commonSearchText",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keywordComputed = $event)),
            placeholder: "レシピや食材で検索する",
            enterkeyhint: "done",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.handleEnter()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.keywordComputed]
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", {
          class: "search-detail-page-button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickClear(...args)))
        }, [
          _hoisted_8
        ]),
        _createVNode("div", {
          class: "search-detail-page-button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch(...args)))
        }, [
          _hoisted_9
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, " 検索対象:" + _toDisplayString(_ctx.selectApplianceText), 1),
        _withDirectives(_createVNode("div", {
          class: "commonButtonText search-detail-page-appliance-edit-text",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showApplianceDialog(...args)))
        }, " 編集 ", 512), [
          [_vShow, _ctx.isShowApplianceEdit()]
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagGroupsInfo, (info) => {
          return (_openBlock(), _createBlock(_component_SearchTagList, {
            class: "search-detail-page-tag-list",
            key: info.tagGroup.id,
            tags: info.tagGroup.tags,
            title: info.tagGroup.description,
            alias: info.tagGroup.alias,
            selectedTags: info.selected,
            onSelectTag: _ctx.setTag
          }, null, 8, ["tags", "title", "alias", "selectedTags", "onSelectTag"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createVNode(_component_CommonDialog, {
      showDialog: !!_ctx.handleApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      onNegativeClick: _ctx.closeDialog,
      onPositiveClick: _ctx.retryGetRecipes
    }, null, 8, ["showDialog", "title", "message", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_ApplianceDialog, {
      list: _ctx.getSearchAppliance,
      showDialog: _ctx.isShowApplianceDialog,
      onCloseClick: _ctx.closeApplianceDialog,
      onPositiveClick: _ctx.positiveApplianceDialog,
      onSelectCheck: _ctx.selectCheck
    }, null, 8, ["list", "showDialog", "onCloseClick", "onPositiveClick", "onSelectCheck"])
  ]))
}